/**
 * Asynchronously loads the component for FeaturePage
 */

import { loadable } from '@elliemae/pui-app-sdk';

export const Matrix = loadable(
  () =>
    import(
      /* webpackChunkName: "Matrix" */ /* webpackPrefetch: true */ './index'
    ),
);
